import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'

import MailchimpForm from '../components/MailchimpForm.js'
import PartnersSection from '../components/PartnersSection'
import EndorsementSection from '../components/EndorsementSection'
import HomepageVideo from '../components/HomepageVideo'

import voteYayImg from '../static/img/vote_yay_square.jpg'
import bgImage from '../static/img/placeholder.jpeg'

const IndexPage = props => {
  return (
    <div>
      <div
        className="container-fluid"
        style={{ borderTop: '1rem solid #5faf36' }}
      />
      <div className="container py-4">
        <div className="row">
          <div className="col">
            <Img
              title="Vote Yay for Prop A. Affordable Housing Bond."
              alt="Vote Yay for Prop A. Affordable Housing Bond."
              sizes={props.data.headerImage.sizes}
            />
            <div
              className="my-3 my-md-4 my-lg-5 mx-xl-5"
              // style={{
              //   background: `url(${bgImage}) no-repeat center center`,
              //   backgroundSize: 'cover',
              //   // background: 'RGBA(0, 0, 0, .1)',
              // }}
            >
              <HomepageVideo />
            </div>
            <h1 style={{ fontWeight: 'bold' }}>
              Austin is in a Housing Crisis.
            </h1>
            <h2 className="mb-3" style={{ fontWeight: 'bold' }}>
              On November 6th, vote for an Austin everyone can afford.
            </h2>
            <div className="row">
              <div className="col-sm-12 col-md-3">
                <img
                  src={voteYayImg}
                  alt="Vote Yay for Prop A Affordable Housing Bond"
                  style={{ maxWidth: '100%' }}
                />
              </div>
              <div className="col mt-2">
                <p>
                  There’s a lot at stake in this year’s election. If we don’t
                  invest in affordable housing programs now, only the most
                  wealthy people will be able to afford to live here.
                </p>

                <p>
                  In Austin, we don’t give up on our neighbors — like Veterans
                  who are at risk of being displaced or living in unsafe
                  conditions; AISD teachers who can’t afford to live in or near
                  the communities they educate; the over 2,000 homeless AISD
                  school students.
                </p>

                <p>
                  Proposition A, the Affordable Housing Bond, will preserve the
                  Austin we love by keeping people of all incomes in their
                  homes. Vote for an Austin everyone can afford.
                </p>
                <h4>#VoteYayforPropA</h4>
              </div>
            </div>

            <h2 className="mt-5">About Us</h2>
            <p>
              Keep Austin Affordable is a coalition of local nonprofits and
              community leaders who believe addressing the housing crisis is a
              high priority for the City and requires investment in programs
              that help people stay in their homes or find affordable housing
              options all over the City.
            </p>
          </div>
        </div>
      </div>
      <EndorsementSection
        statesmanImage={props.data.statesmanImage}
        chronicleImage={props.data.chronicleImage}
      />
      <PartnersSection
        aborImage={props.data.aborImage}
        mealsOnWheelsImage={props.data.mealsOnWheelsImage}
        affordableCTXImage={props.data.affordableCTXImage}
        austinHousingCoalitionImage={props.data.austinHousingCoalitionImage}
        habitatForHumanityImage={props.data.habitatForHumanityImage}
        foundationCommunitiesImage={props.data.foundationCommunitiesImage}
        safeImage={props.data.safeImage}
        housingWorksAustinImage={props.data.housingWorksAustinImage}
        austinUrbanLeagueImage={props.data.austinUrbanLeagueImage}
        allianceForRetiredAmericansImage={
          props.data.allianceForRetiredAmericansImage
        }
        easterSealsImage={props.data.easterSealsImage}
        caritasImage={props.data.caritasImage}
        dmaImage={props.data.dmaImage}
        echoImage={props.data.echoImage}
        lifeworksImage={props.data.lifeworksImage}
        austinCommunityDesignCenterImage={
          props.data.austinCommunityDesignCenterImage
        }
        gndcImage={props.data.gndcImage}
      />
      <Img
        title="Photo from June 2018 Rally at City Hall"
        alt="Crowd of Affordable Housing Supporters Rally at City Hall in June 2018"
        sizes={props.data.homeImage.sizes}
        style={{ width: '100%', maxHeight: '90vh' }}
      />
      {/* <MailchimpForm /> */}
    </div>
  )
}

export default IndexPage

export const query = graphql`
  query HomePageQuery {
    homeImage: imageSharp(id: { regex: "/june_rally_cropped/" }) {
      sizes(maxWidth: 1500, rotate: 180) {
        ...GatsbyImageSharpSizes
      }
    }
    headerImage: imageSharp(id: { regex: "/VoteYay_Long_4C/" }) {
      sizes(maxWidth: 1140) {
        ...GatsbyImageSharpSizes_noBase64
      }
    }
    mealsOnWheelsImage: imageSharp(id: { regex: "/meals_on_wheels/" }) {
      resolutions(width: 200) {
        ...GatsbyImageSharpResolutions_noBase64
      }
    }
    affordableCTXImage: imageSharp(id: { regex: "/affordable_central_tx/" }) {
      resolutions(width: 200) {
        ...GatsbyImageSharpResolutions_noBase64
      }
    }
    austinHousingCoalitionImage: imageSharp(
      id: { regex: "/austin_housing_coalition/" }
    ) {
      resolutions(width: 200) {
        ...GatsbyImageSharpResolutions_noBase64
      }
    }
    habitatForHumanityImage: imageSharp(
      id: { regex: "/habitat_for_humanity/" }
    ) {
      resolutions(width: 200) {
        ...GatsbyImageSharpResolutions_noBase64
      }
    }
    foundationCommunitiesImage: imageSharp(
      id: { regex: "/foundation_communities/" }
    ) {
      resolutions(width: 200) {
        ...GatsbyImageSharpResolutions_noBase64
      }
    }
    safeImage: imageSharp(id: { regex: "/SAFE/" }) {
      resolutions(width: 200) {
        ...GatsbyImageSharpResolutions_noBase64
      }
    }
    aborImage: imageSharp(id: { regex: "/ABOR/" }) {
      resolutions(width: 200) {
        ...GatsbyImageSharpResolutions_noBase64
      }
    }
    housingWorksAustinImage: imageSharp(
      id: { regex: "/housingworks_austin/" }
    ) {
      resolutions(width: 200) {
        ...GatsbyImageSharpResolutions_noBase64
      }
    }
    austinUrbanLeagueImage: imageSharp(
      id: { regex: "/Austin_Area_Urban_League/" }
    ) {
      resolutions(width: 200) {
        ...GatsbyImageSharpResolutions_noBase64
      }
    }
    allianceForRetiredAmericansImage: imageSharp(
      id: { regex: "/alliance_for_retired_americans/" }
    ) {
      resolutions(width: 200) {
        ...GatsbyImageSharpResolutions_noBase64
      }
    }
    easterSealsImage: imageSharp(id: { regex: "/easterseals/" }) {
      resolutions(width: 200) {
        ...GatsbyImageSharpResolutions_noBase64
      }
    }
    caritasImage: imageSharp(id: { regex: "/caritas/" }) {
      resolutions(width: 200) {
        ...GatsbyImageSharpResolutions_noBase64
      }
    }
    dmaImage: imageSharp(id: { regex: "/dma_companies/" }) {
      resolutions(width: 200) {
        ...GatsbyImageSharpResolutions_noBase64
      }
    }
    echoImage: imageSharp(id: { regex: "/echo/" }) {
      resolutions(width: 200) {
        ...GatsbyImageSharpResolutions_noBase64
      }
    }
    lifeworksImage: imageSharp(id: { regex: "/lifeworks/" }) {
      resolutions(width: 200) {
        ...GatsbyImageSharpResolutions_noBase64
      }
    }
    austinCommunityDesignCenterImage: imageSharp(
      id: { regex: "/Austin_Community_Design_and_Development_Center/" }
    ) {
      resolutions(width: 200) {
        ...GatsbyImageSharpResolutions_noBase64
      }
    }
    gndcImage: imageSharp(id: { regex: "/GNDC/" }) {
      resolutions(width: 200) {
        ...GatsbyImageSharpResolutions_noBase64
      }
    }
    statesmanImage: imageSharp(id: { regex: "/statesman_logo/" }) {
      resolutions(width: 350) {
        ...GatsbyImageSharpResolutions_noBase64
      }
    }
    chronicleImage: imageSharp(id: { regex: "/austin_chronicle/" }) {
      resolutions(width: 350) {
        ...GatsbyImageSharpResolutions_noBase64
      }
    }
    site {
      siteMetadata {
        facebookUrl
        eventUrl
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js